import { apiClient } from '@/services/utils';

export default {
  get(productId) {
    return apiClient.get(`/products/${productId}`);
  },

  create(productUrl) {
    const params = { product: { product_url: productUrl } }

    return apiClient.post(`/products/`, params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/ProductService.js